import ContactTile from "@gik/contact/components/ContactTile/ContactTile";
import { translationKeys } from "@gik/contact/i18n/en";
import { useBemCN } from "@gik/core/utils/bemBlock";
import { ExternalLink } from "@gik/ui-legacy/ExternalLink";
import { Facebook } from "@gik/ui-legacy/SvgIcon/BrandIcons/Facebook";
import { Instagram } from "@gik/ui-legacy/SvgIcon/BrandIcons/Instagram";
import { Pinterest } from "@gik/ui-legacy/SvgIcon/BrandIcons/Pinterest";
import { Twitter } from "@gik/ui-legacy/SvgIcon/BrandIcons/Twitter";
import { SvgIcon } from "@gik/ui-legacy/SvgIcon/SvgIcon";
import React from "react";
import { useTranslation } from "react-i18next";

export default function Connect() {
	const bem = useBemCN("connect");
	const { t } = useTranslation();

	return (
		<ContactTile {...bem()} title={t(translationKeys.ConnectTitle)}>
			<div>
				<ExternalLink href="https://www.facebook.com/giveinkind/">
					<SvgIcon Icon={Facebook} size="2xl" />
				</ExternalLink>
				<ExternalLink href="https://www.pinterest.com/giveinkind">
					<SvgIcon Icon={Pinterest} size="2xl" />
				</ExternalLink>
				<ExternalLink href="https://www.instagram.com/giveinkind/">
					<SvgIcon Icon={Instagram} size="2xl" />
				</ExternalLink>
				<ExternalLink href="https://twitter.com/giveinkind">
					<SvgIcon Icon={Twitter} size="2xl" />
				</ExternalLink>
			</div>
		</ContactTile>
	);
}
